import React from "react";

import { Link } from "react-router-dom";

import { PageHeader, Descriptions, Divider, Tabs, Button } from "antd";
import { Card, Col, Row } from "antd";

import Component from "../formComponent";

import {
    LAYOUT_MANAGER_PROJECT_EDIT,
    LAYOUT_MANAGER_PROJECT_POS_NEW,
    LAYOUT_MANAGER_PROJECT_POS_EDIT,
} from "../../navigation";

const { TabPane } = Tabs;

/**
 *
 */
export default class Show extends React.Component {
    constructor(props) {
        super(props);
        const { data } = this.props;

        let showModal = [];
        showModal[0] = false;
        (data.project.points_of_sale || []).forEach((pos) => {
            showModal[pos.id] = false;
        });

        this.state = {
            id: props.match.params.id,
            showModal: showModal,
        };
    }

    _goBack = () => {
        this.props.history.goBack();
    };

    /*
    showModal = (index) => {
        let showModal = this.state.showModal;
        showModal[index] = true;
        this.setState({
            showModal: showModal,
        });
    }

    closeModal = (index) => {
        let showModal = this.state.showModal;
        showModal[index] = false;
        this.setState({
            showModal: showModal,
        });
    }
    */

    render() {
        const { data } = this.props;

        return (
            <>
                <div className="site-page-header-ghost-wrapper">
                    <PageHeader
                        ghost={false}
                        className="site-page-header"
                        onBack={this._goBack}
                        title={data.project.name}
                        subTitle="Project"
                        extra={[
                            <Link key="1" to={LAYOUT_MANAGER_PROJECT_EDIT(this.state.id)}>
                                <Button type="primary" size="small">
                                    <i className="fa fa-pencil-square-o"></i>
                                    <Divider type="vertical" />
                                    Update
                                </Button>
                            </Link>,
                        ]}
                    >
                        <Divider orientation="left" plain>
                            {" "}
                            Primary Contact
                        </Divider>
                        <Descriptions size="medium" column={3}>
                            <Descriptions.Item label="Name">
                                {data.project.last_name}, {data.project.first_name}
                            </Descriptions.Item>
                            <Descriptions.Item label="Phone"> {data.project.phone} </Descriptions.Item>
                            <Descriptions.Item label="Email"> {data.project.email} </Descriptions.Item>
                            <Descriptions.Item label="Skype"> {data.project.skype} </Descriptions.Item>
                            <Descriptions.Item label="Notes"> {data.project.description} </Descriptions.Item>
                        </Descriptions>
                    </PageHeader>
                </div>

                <Divider />
                <div className="site-page-header-ghost-wrapper">
                    <PageHeader
                        ghost={false}
                        title="Points of Sale"
                        subTitle="POS"
                        extra={[
                            <Link key="1" to={LAYOUT_MANAGER_PROJECT_POS_NEW(data.project.id)}>
                                <Button size="small">
                                    <i className="fa fa-pencil-square-o"></i>
                                    <Divider type="vertical" />
                                    NEW
                                </Button>
                            </Link>,
                        ]}
                        className="site-page-header"
                    >
                        <Tabs size="large" tabBarExtraContent={<h4>POS</h4>}>
                            {(data.project.points_of_sale || []).map((pos) => (
                                <TabPane tab={pos.name} key={pos.id.toString()}>
                                    <div className="site-card-wrapper">
                                        <Row>
                                            <Col>
                                                <Card
                                                    size="small"
                                                    title={
                                                        <Link
                                                            to={LAYOUT_MANAGER_PROJECT_POS_EDIT(this.state.id, pos.id)}
                                                        >
                                                            <i className="fa fa-pencil-square-o"></i> Update Contact
                                                            Information
                                                        </Link>
                                                    }
                                                    bordered={false}
                                                >
                                                    <Descriptions size="small" column={2}>
                                                        <Descriptions.Item label="Code">{pos.code}</Descriptions.Item>
                                                        <Descriptions.Item label="Notes">{pos.notes}</Descriptions.Item>

                                                        <Descriptions.Item label="Contact">
                                                            {" "}
                                                            {pos.last_name}, {pos.first_name}{" "}
                                                        </Descriptions.Item>
                                                        <Descriptions.Item label="Phone">
                                                            {" "}
                                                            {pos.phone}{" "}
                                                        </Descriptions.Item>
                                                        <Descriptions.Item label="Email">
                                                            {" "}
                                                            {pos.email}{" "}
                                                        </Descriptions.Item>
                                                        <Descriptions.Item label="Skype">
                                                            {" "}
                                                            {pos.skype}{" "}
                                                        </Descriptions.Item>
                                                    </Descriptions>
                                                    <Component
                                                        projectId={this.state.id}
                                                        posId={pos.id}
                                                        components={pos.components || []}
                                                    />
                                                </Card>
                                            </Col>
                                        </Row>
                                    </div>
                                </TabPane>
                            ))}
                        </Tabs>
                    </PageHeader>
                </div>
                <Divider />
            </>
        );
    }
}
